const SchemeCountsTable = ({ schemeCounts, schemeNamesWithCode, schemeColors }) => {
  if (!schemeCounts || schemeCounts.length === 0) {
    return <div className="alert alert-info">No scheme data available</div>;
  }

  return (
   <div className="mapRightBhuvanAnalytics mt-2">
      <div className="mapheader">
        <h2 className="mb-0">All Schemes Data</h2>
      </div>
      
        <div className="table-responsive allschemeScroll">
       
         <table className="table table-bordered table-striped table-hover">
            <thead>
              <tr>
                <th width="50px">S.No.</th>
                <th>Scheme Name</th>
                <th>Surveys</th>
              </tr>
            </thead>
            <tbody>
              {schemeCounts.map((scheme, index) => (
                <tr key={scheme.schemeCode}>
                  <td className="text-center">{index + 1}</td>
                  <td>
                    {/* <span 
                      className="color-badge me-2" 
                      style={{
                        backgroundColor: schemeColors[scheme.schemeCode] || '#ccc',
                        width: '15px',
                        height: '15px',
                        display: 'inline-block',
                        borderRadius: '3px',
                        verticalAlign: 'middle'
                      }}
                    ></span> */}
                    {scheme.schemeName}
                  </td>
                  <td className="text-end">
                    <strong>{scheme.totalSurvey.toLocaleString()}</strong>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      
    </div>
  );
};

export default SchemeCountsTable;